import { useFormContext } from 'react-hook-form';
import Styles from '../../../../../common/deals/new/DealEditorBody.module.scss';
import type { RelatedDealParam } from '~/models/DealForm';
import type { Deal } from '~/models/Deal';
import { RoomBlock } from './block/RoomBlock';
import { TenantBlock } from './block/TenantBlock';
import { DealTypeBlock } from '~/components/common/deals/new/block/DealTypeBlock';
import { MoveOutBlock } from '~/components/common/deals/new/block/MoveOutBlock';
import { OtherBlock } from '~/components/common/deals/new/block/OtherBlock';
import { RepairBlock } from '~/components/common/deals/new/block/RepairBlock';

type Props = { deal: Deal };

export const DealEditorBody: React.FC<Props> = ({ deal }) => {
  const { watch } = useFormContext<RelatedDealParam>();
  const dealType = watch('dealType');

  return (
    <div className={Styles.DealEditorBody}>
      <DealTypeBlock isRelatedDeal />
      <RoomBlock deal={deal} />
      {dealType === 'repair' && <RepairBlock />}
      <TenantBlock deal={deal} />
      <MoveOutBlock deal={deal} dealType={dealType} leasing={null} />
      <OtherBlock deal={deal} />
    </div>
  );
};
